import(/* webpackMode: "eager" */ "/codebuild/output/src191552198/src/github.com/bitstone/offerz-nextjs/src/app/[lang]/(main)/not-found.tsx");
